import classNames from "classnames";
import { BrevForloeb } from "core/sharedmodels/forloeb/brevForloebDto";
import { GenericGetUddannelsesstedInfo } from "core/sharedmodels/forloeb/forloebSimpleInfoModel";
import { GetFravaerskodeTranslation } from "core/sharedmodels/forloeb/fravaerskoderEnum";
import { UddannelseTypeEnum } from "core/sharedmodels/stilling/uddannelseTypeEnum";
import { Localizer } from "infrastructure/localization/localizer";
import { ForloebOverviewEmptyCard } from "pages/forloeb/forloebOverviews/forloebOverviewEmptyCard";

const EmptyList = () => (
    <ForloebOverviewEmptyCard emptyText={Localizer.letterPage_letterListEmptyInfo()}>
        <p>{Localizer.forloebpage_NoForloeb()}</p>
    </ForloebOverviewEmptyCard>
);

const headers = [
    Localizer.global_periode(),
    Localizer.global_forloeb()
];

const getFravaersDisplay = (f: BrevForloeb) =>  f.isFravaer && f.fravaerskodeEnum ? `${f.fravaerskodeEnum} - ${GetFravaerskodeTranslation(f.fravaerskodeEnum)},` : "";
const getUddannelsestrinDisplay = (f: BrevForloeb) => f.isFravaer ? "" : `${UddannelseTypeEnum[f.uddannelseType]},`;
const getUddannelsesInfo = (f: BrevForloeb) => GenericGetUddannelsesstedInfo(!!f.afdelingName, f.laegeInstitutionName, f.afdelingName);

const getForloebInfo = (f: BrevForloeb) => `${getUddannelsesInfo(f)}, (${f.stillingNummer}), ${getFravaersDisplay(f)} ${getUddannelsestrinDisplay(f)} ${f.specialeName}`;

// Note: The internal styles/classes uses here, will not propagate to the PDF (because of HTML-sanitization in TextEditorModule, which cannot be overridden as of now)
// Therefore make sure any changes here, is made in "brevskabelonPDf.scss" aswell
// Styling based upon data is not possible to align, because we cannot use classes inside the sanitized HTML - e.g. "bg-fravaer"
const ForloebListBrevskabelonMergefield = ({forloebs} : {forloebs: BrevForloeb[]}) => {

    const hasForloeb = forloebs.length > 0;

    return (
        <table>
            <thead>
                <tr>
                    {headers.map(txt => <th key={txt}>{txt}</th>)}
                </tr>
            </thead>
            <tbody>
                {hasForloeb &&  forloebs.map((f, index) => (
                    <tr key={f.id} className={classNames(f.isFravaer && "bg-fravaer", (f.isManueltAfsluttet && !f.isFravaer) && "bg-warning")}>
                        <td style={{ whiteSpace: "nowrap" }}>{`${f.startDate.dateWithoutTimeFormat(false)} - ${f.endDate.dateWithoutTimeFormat(false)}`}</td>
                        <td>
                            <div>{getForloebInfo(f)}</div>
                            {f.attestationForTidInfotekst && 
                                <>
                                    <br/>
                                    <em>{f.attestationForTidInfotekst}</em>
                                </>
                            }
                        </td>
                    </tr>
                ))}

                {!hasForloeb &&
                    <tr>
                        <td colSpan={headers.length}>
                            <div className="margin-top-s">
                                <EmptyList />
                            </div>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    )
}

export default ForloebListBrevskabelonMergefield;